import { ICriteria } from '../contracts/criteria.contract';

const criteriaDescription: { [key in keyof ICriteria]?: string } = {
    FishingVessel: 'Fishing Vessel',
    SelfPropelled: 'Self-Propelled Mobile Offshore Drilling Unit',
    RoRoVessel: 'RoRo Vessel',
    RoRoVehicleCarrier: 'RoRo Vehicle Carrier',
    RoRoCargoShip: 'RoRo Cargo Ship',
    RoRoPassengerShip: 'RoRo Passenger Ship',
    HighSpeedCraft: 'High-Speed Craft',
    MobileOffshoreDrillingUnit: 'Mobile Offshore Drilling Unit',
    PassengerShip: 'Passenger',
    CruisePassenger: 'Cruise Passenger',
    CargoShip: 'Cargo Ship',
    DynamicallySupportedCraft: 'Dynamically Supported Craft',
    ContainerCarrier: 'Container Carrier',
    GeneralCargoCarrier: 'General Cargo Carrier',
    RefrigeratedCargoCarrier: 'Refrigerated Cargo Carrier',
    Tanker: 'Tanker',
    OilTanker: 'Oil Tanker',
    ChemicalCarrier: 'Chemical Carrier',
    GasLNGCarrier: 'Gas Carrier',
    LNGCarrier: 'LNG Carrier',
    NonLNGGasCarrier: 'Non-LNG Gas Carrier',
    CrudeTanker: 'Crude Tanker',
    ProductTanker: 'Product Tanker',
    BulkCarrier: 'Bulk Carrier',
    CombinationCarrier: 'Combination Carrier',
    OreCarrier: 'Ore Carrier',
    OffshoreSupportVessel: 'Offshore Support Vessel',
    EntryIntoForceAfterDate: 'Entry into Effect After Date',
    EntryIntoForceBeforeDate: 'Entry into Effect Before Date',
    Mandatory: 'Mandatory',
    Guideline: 'Guideline',
    Hardware: 'Hardware',
    Operational: 'Operational',
    Retroactive: 'Retroactive',
    New: 'New',
    GrossTonnage: 'Gross Tonnage',
    NumberOfPassengers: 'Number of Passengers',
    Deadweight: 'Deadweight (DWT)',
    LoadLineLength: 'Load Line Length (LLL)',
    LengthOverall: 'Length Overall (LOA)',
    ContractAfterDate: 'Contract After Date',
    ContractBeforeDate: 'Contract Date',
    KeelLayAfterDate: 'Keel Lay After Date',
    KeelLayBeforeDate: 'Keel Lay Date',
    DeliveryAfterDate: 'Delivery After Date',
    DeliveryBeforeDate: 'Delivery Date',
    MARPOL: 'MARPOL',
    SOLAS: 'SOLAS',
    STCW: 'STCW',
    AFS: 'AFS',
    ICLL: 'ICLL',
    BWM: 'BWM',
    ExpiryAfterDate: 'Expiry After Date',
    ExpiryBeforeDate: 'Expiry Before Date',
    UserSearchQuery: 'Text Search'
};

const IGF_CODE_APPLICABLE = 'IGF Code Applicable';

// Translates selected criteria properties into human-readable descriptions
const getDescriptionByCriteria = (criteria: ICriteria): string[] => {
    const descriptions = Object.keys(criteria)
        .filter((key) => key !== 'IGFCode' && criteria[key as keyof ICriteria])
        .map((key) => criteriaDescription[key as keyof ICriteria]!)
        .filter((description) => description !== undefined);

    // Only show chip when IGF toggle is On (include IGF-related amendments)
    if (criteria.IGFCode === true) {
        descriptions.push(IGF_CODE_APPLICABLE);
    }

    return descriptions;
};

const getCriteriaPropertyByDescription = (description: string): keyof ICriteria | undefined => {
    if (description === IGF_CODE_APPLICABLE) {
        return 'IGFCode';
    }

    return (Object.keys(criteriaDescription) as (keyof ICriteria)[]).find((key) => criteriaDescription[key] === description);
};

const CriteriaText = {
    criteriaDescription,
    getDescriptionByCriteria,
    getCriteriaPropertyByDescription
};

export default CriteriaText;
